import $ from 'jquery';
import select2 from 'select2/dist/js/select2.full';
select2($);

export function InitSelect2(block) {
  const dropdowns = block.querySelectorAll(".dropdown");
  
  function initSelect(elm) {
    const placeholderText = elm.getAttribute("data-placeholder");
    const svgArrow = `
      <svg width="25" height="13" viewBox="0 0 25 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.21094 1.96094L12.1899 11.2208C12.5848 11.5873 13.1991 11.575 13.579 11.193L22.7628 1.96094" stroke="#E6DDC6" stroke-width="2" stroke-linecap="square"/>
      </svg>
    `;
    
    $(elm).select2({
      width: "100%",
      minimumResultsForSearch: -1,
      dropdownParent: $(elm).closest('.select2-wrapper'),
      placeholder: placeholderText,
      allowClear: true
    });
    
    $(elm).next('.select2').find('.select2-selection__arrow').html(svgArrow);
  }
  
  dropdowns.forEach(initSelect);
}
